/**
 * Mouvement du bandeau PAF (repris du runtime parallaxe du site) :
 * chaque ligne glisse horizontalement selon la progression du bandeau dans
 * l'écran (0 = il entre par le bas, 1 = il sort par le haut). Les lignes
 * paires vont de -amplitude à +amplitude, les impaires dans l'autre sens,
 * toutes passent par 0 au milieu. Chaque ligne a son propre lissage
 * (« scrub ») : la première traîne, la dernière colle au scroll.
 */
export const PAF_BAND_SCRUB = [1, 0.8, 0.6, 0.4, 0.2, 0] as const;

/** Amplitude du site : 10 % de la largeur de l'écran. */
export const PAF_BAND_AMPLITUDE_VW = 10;

export function pafBandTarget(progress: number, index: number, amplitude: number): number {
  const p = Math.min(1, Math.max(0, progress));
  const sign = index % 2 === 0 ? 1 : -1;
  const value = sign * (p - 0.5) * 2 * amplitude;
  return value === 0 ? 0 : value;
}

/** Progression 0..1 d'un élément dans l'écran (formule du site). */
export function pafBandProgress(rectTop: number, rectHeight: number, viewportHeight: number): number {
  return Math.min(1, Math.max(0, (viewportHeight - rectTop) / (viewportHeight + rectHeight)));
}

/** Part de la distance restante franchie en `elapsed` secondes pour un scrub donné (ease exponentiel de ScrollTrigger). */
export function pafBandSmoothing(elapsed: number, scrub: number): number {
  if (scrub === 0) return 1;
  return 1 - Math.exp(-elapsed / Math.max(scrub / Math.log(1024), 0.001));
}
